module.exports = __webpack_public_path__ + "static/img/but.92a8d3c3.png";